import React from 'react';
import styled from 'styled-components';

import {nl2br} from '@tager/web-core';

import {useCurrentPage} from '@/hooks/useCurrentPage';
import ContentContainer from '@/components/ContentContainer';
import {DveriContactsPageType} from '@/typings/model';
import {normalizePhoneNumber} from '@/utils/common';

import {ReactComponent as EmailSvg} from './assets/email.svg';
import {ReactComponent as PhoneSvg} from './assets/phone.svg';
import {ReactComponent as WorkTimeSvg} from './assets/worktime.svg';
import mapImg from './assets/map.jpg';

const DveriContacts = () => {
  const page = useCurrentPage<DveriContactsPageType>();

  if (!page) return null;

  return (
    <ContentContainer>
      <Component>
        <Left>
          <LeftInner>
            <Title>{page.title}</Title>
            {page.templateFields.address && (
              <Address>{nl2br(page.templateFields.address)}</Address>
            )}
            {page.templateFields.email && (
              <Param>
                <ParamLink href={`mailto:${page.templateFields.email}`}>
                  <EmailSvg/>
                  {page.templateFields.email}
                </ParamLink>
              </Param>
            )}
            {page.templateFields.phone ? (
              <Param>
                <ParamLink
                  href={`tel:${normalizePhoneNumber(
                    page.templateFields.phone
                  )}`}
                >
                  <PhoneSvg/>
                  {page.templateFields.phone}
                </ParamLink>
              </Param>
            ) : null}

            {page.templateFields.phoneSecond ? (
              <Param>
                <ParamLink
                  href={`tel:${normalizePhoneNumber(
                    page.templateFields.phoneSecond
                  )}`}
                >
                  <PhoneSvg/>
                  {page.templateFields.phoneSecond}
                </ParamLink>
              </Param>
            ) : null}

            <Param>
              <WorkTimeSvg/>
              {page.templateFields.workTime}
            </Param>
          </LeftInner>
        </Left>
        <Right>
          <Title>{page.templateFields.mapTitle}</Title>

          <img src={mapImg} alt=""/>
        </Right>
      </Component>
    </ContentContainer>
  );
};

const Component = styled.div`
  margin: 15px 0;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  flex: 1;

  img {
    height: auto;
  }
`;

const Right = styled.div`
  flex: 1;
`;

const LeftInner = styled.div``;

const Title = styled.h1`
  font-size: 24px;
`;

const Address = styled.p`
  display: block;
  margin-top: 30px;
  font-size: 16px;
  line-height: 32px;
  margin-bottom: 20px;
`;

const Param = styled.span`
  display: flex;
  margin-top: 20px;
  align-items: center;
  gap: 10px;

  a {
    display: inline-flex;
  }
`;

const ParamLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 10px;

  &:hover {
    opacity: 0.7;
  }
`;

const Buttons = styled.div`
  margin-top: 30px;
`;

export default DveriContacts;
